/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type PredictionMarketConfigResolvePriceCubeFormat =
  (typeof PredictionMarketConfigResolvePriceCubeFormat)[keyof typeof PredictionMarketConfigResolvePriceCubeFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PredictionMarketConfigResolvePriceCubeFormat = {
  DOLLARS: 'DOLLARS',
  CONTRACTS: 'CONTRACTS',
} as const;
